// src/components/layout/Header.tsx
import React from 'react';
import { AuthButton } from '../auth/AuthButton';
import type { User } from '../../types/auth';

interface HeaderProps {
  user: User | null;
  isAuthenticated: boolean;
  remainingCalls: number;
  onShowHistory: () => void;
  onShowLogin: () => void;
  onSignOut: () => void;
}

export const Header: React.FC<HeaderProps> = ({
  user,
  isAuthenticated,
  onShowLogin,
  onSignOut
}) => {
  return (
    <header className="bg-white shadow-sm border-b">
      <div className="flex items-center justify-between py-3 lg:py-4 px-4 lg:px-8">
        {/* Left side - Logo */}
        <div className="flex items-center">
          <img 
            src="/dairy_translate_logo.png" 
            alt="DairyTranslate Logo" 
            className="h-8 lg:h-12 w-auto"
          />
        </div>
        
        {/* Center - Title */}
        <div className="hidden lg:block absolute left-1/2 transform -translate-x-1/2">
          <h1 className="text-2xl lg:text-3xl font-bold text-gray-900">Dairy Translate</h1>
        </div>
        
        {/* Mobile Center Title */}
        <div className="lg:hidden flex-1 text-center">
          <h1 className="text-lg font-bold text-gray-900">Dairy Translate</h1>
        </div>
        
        {/* Right side - Login */}
        <div className="flex items-center space-x-2 lg:space-x-6">
          <AuthButton
            user={user}
            isAuthenticated={isAuthenticated}
            onShowLogin={onShowLogin}
            onSignOut={onSignOut}
          />
        </div>
      </div>
    </header>
  );
};